/** O'zbek (lotin) — birinchi til. Boshqa tillar shu kalitlarni takrorlaydi. */
export default {
  app: { name: 'Kitobxonlik', tagline: 'Moliya vazirligi xodimlari kutubxonasi' },
  nav: {
    library: 'Kutubxona',
    home: 'Asosiy',
    myBooks: 'Mening kitoblarim',
    calendar: 'Kalendar',
    exams: 'Imtihonlarim',
    myStats: 'Körsatkiçlarim',
    admin: 'Boşqaruv',
    statistics: 'Statistika',
    dashboard: 'Körsatkiçlar',
    books: 'Kitoblar',
    examsAdmin: 'Imtihonlar',
    organizations: 'Taşkilotlar',
    dictionaries: 'Luğatlar',
    roles: 'Rollar va ruxsatlar',
    users: 'Foydalanuvçilar',
    signOut: 'Çiqiş',
  },
  common: {
    search: 'Qidiriş',
    filter: 'Filtr',
    clear: 'Tozalaş',
    save: 'Saqlaş',
    cancel: 'Bekor qiliş',
    delete: 'Öçiriş',
    edit: 'Tahrirlaş',
    create: 'Qöşiş',
    back: 'Orqaga',
    loading: 'Yuklanmoqda…',
    nothing: 'Heç narsa topilmadi',
    all: 'Barçasi',
    yes: 'Ha',
    no: 'Yöq',
    confirm: 'Tasdiqlaş',
    success: 'Muvaffaqiyatli bajarildi',
    error: 'Xatolik yuz berdi',
    page: 'Sahifa',
    of: 'dan',
    total: 'Jami',
    author: 'Muallif',
    year: 'Yil',
    pages: 'Sahifalar',
    genre: 'Janr',
    subject: 'Mavzu',
    sphere: 'Soha',
    status: 'Holat',
    date: 'Sana',
    time: 'Vaqt',
    employee: 'Xodim',
    book: 'Kitob',
    actions: 'Amallar',
    download: 'Yuklab oliş',
    upload: 'Yuklaş',
    replace: 'Almaştiriş',
    open: 'Oçiş',
    retry: 'Qayta uriniş',
    home: 'Boş sahifa',
    organization: 'Taşkilot',
    details: 'Ma’lumotlar',
    type: 'Turi',
    who: 'Kim',
    rating: 'Baho',
    correct: 'Töğri',
    incorrect: 'Notöğri',
    format: 'Formatlar',
    from: 'Boşlaniş',
    to: 'Tugaş',
    notFound: 'Sahifa topilmadi',
    staleLink: 'Havola eskirgan bölişi mumkin.',
    skipToContent: 'Asosiy kontentga ötiş',
    mainMenu: 'Asosiy menyu',
    openMenu: 'Menyuni oçiş',
    breadcrumbs: 'Yöl',
    orgNumber: 'Taşkilot #{id}',
    devSession: 'Dev sessiya',
    copyright: '© {year} Kitobxonlik · Iqtisodiyot va moliya vazirligi',
    pageCount: '{n} bet',
    times: '{n} marta',
    unknownError: 'Serverda xatolik',
  },
  book: {
    year: '{year}-yil',
    passedBy: '{n} topşirgan',
    bonusTag: 'Bonus {n}%',
    /** Kitob kartochkasidagi qisqa holat yorliqlari (jadvaldagi uzun nomlardan farqli) */
    badge: {
      passed: 'Topşirilgan',
      scheduled: 'Rejada',
      inProcess: 'Jarayonda',
      retake: 'Qayta',
      closed: 'Yopilgan',
    },
    /** Kitobda nima bor (BookAvailability ikonkalari va kitob sahifasi chiplari) */
    avail: {
      label: 'Mavjud',
      pdf: 'Elektron kitob (PDF) yuklangan',
      test: 'Test tayyor',
    },
  },
  file: {
    uploaded: 'Fayl yuklandi',
    present: 'Fayl yuklangan',
    none: 'Fayl tanlanmagan',
    remove: 'Faylni olib taşlaş',
    ebookPdfOnly: 'Elektron kitob faqat PDF formatida yuklanadi',
    ebookTooLarge: 'Elektron kitob {max} MB gaça bölişi kerak — tanlangan fayl {size} MB',
  },
  session: {
    noSession: 'Sessiya topilmadi',
    entryFailed: 'Kirib bölmadi',
    noSessionHint: 'Davom etiş uçun OneID orqali tizimga kiring.',
    hrEntryFailed:
      'HR portalidagi havola eskirgan — qaytadan urinib köring yoki OneID bilan kiring.',
    hrEntryPending: 'HR portalidan kirilmoqda…',
    signIn: 'Kiriş',
    goToHr: 'HR portaliga ötiş',
    devSwitcher: 'Dev: SSO‘siz kiriş',
    logout: 'Çiqiş',
    forbidden: 'Bu bölimga kiriş huquqingiz yöq',
    yourRoles: 'Rollaringiz: {roles}',
  },

  login: {
    title: 'Kitobxonlikka kiriş',
    hint: 'OneID (IMV ID) orqali kiring. Tizimdan faqat HR bazasida xodim sifatida röyxatdan ötganlar foydalana oladi.',
    withOneId: 'IMV ID orqali kiriş',
    pending: 'Kirilmoqda…',
    footer:
      '© {year} Özbekiston Respublikasi Iqtisodiyot va moliya vazirligi huzuridagi Axborot texnologiyalari markazi',
    errors: {
      noVerifier:
        'Kiriş jarayoni uzilib qolgan (boşqa oyna yoki tozalangan xotira). Qaytadan urinib köring.',
      badState: 'Kiriş sörovi mos kelmadi. Xavfsizlik uçun bekor qilindi — qaytadan urinib köring.',
      failed: 'Kirişda xatolik yuz berdi. Qaytadan urinib köring.',
    },
  },

  roles: {
    title: 'Rollar va ruxsatlar',
    sub: 'Har bir rolga qaysi amallar ruxsat etilişini şu yerda belgilaysiz. Özgariş darhol kuçga kiradi.',
    permission: 'Ruxsat',
    newRole: 'Yangi rol',
    code: 'Kod',
    codeHint:
      'Kod faqat BOŞ HARF, raqam va pastki çiziqdan iborat böladi (masalan KUZATUVCHI) va keyin özgartirilmaydi.',
    name: 'Nomi',
    description: 'Izoh',
    empty: 'Rollar topilmadi',
    usersCount: '{count} ta foydalanuvçi',
    deleteTitle: 'Rolni öçiriş',
    deleteConfirm:
      '«{name}» roli öçiriladi. U biriktirilgan {count} ta foydalanuvçi bu ruxsatlarni yöqotadi.',
    groups: {
      library: 'Kutubxona',
      exam: 'Imtihon',
      content: 'Kontent',
      analytics: 'Tahlil',
      access: 'Kiriş nazorati',
      developer: 'Dasturçi',
    },
    developerOnly: 'Bu ruxsat faqat DEVELOPER roliga beriladi',
  },

  users: {
    title: 'Foydalanuvçilar',
    sub: 'Tizim foydalanuvçilari va ularning rollari. Xodim OneID yoki HR havolasi orqali birinçi kirganda röyxatga avtomatik qöşiladi. HR tizimida röyxatdan ötgan xodimni oldindan qöşib, rol biriktiriş ham mumkin.',
    searchPlaceholder: 'JŞŞIR yoki ism böyiça qidiriş',
    employee: 'Xodim',
    org: 'Taşkilot',
    role: 'Rol',
    roles: 'Rollar',
    noRoles: 'Rol yöq',
    lastLogin: 'Oxirgi kiriş',
    active: 'Faol',
    purge: 'Öçiriş',
    purgeTitle: 'Foydalanuvçini öçiriş',
    purgeConfirm:
      '«{name}» (JŞŞIR {pinfl}) öçiriladi: rollari, imtihonlari va ularning videolari, kitob holatlari, sevimlilari, yuklab olişlari, baholari va kalendari tizimda körinmay qoladi (bazada öçirilgan deb belgilanib saqlanadi), sessiyalari yopiladi. Ilovadan qaytarib bölmaydi. HR’da xodim bölsa, keyingi kirişda yangi foydalanuvçi sifatida (tarixsiz) paydo böladi.',
    purged: 'Foydalanuvçi öçirildi: {exams} ta imtihon, {books} ta kitob holati',
    add: 'Foydalanuvçi qöşiş',
    addHint: 'JŞŞIRni kiriting — xodim HR tizimida tekşiriladi. Ism va taşkilot HR’dan olinadi.',
    pinfl: 'JŞŞIR',
    pinflPlaceholder: '14 ta raqam',
    check: 'HR’dan tekşiriş',
    exists: 'Bu xodim tizimda allaqaçon bor — rollarini röyxatda özgartiring.',
    showInList: 'Röyxatda körsatiş',
    addRoles: 'Rollar',
    added: '«{name}» qöşildi',
  },
  chart: {
    type: 'Diagramma turi',
    donut: 'Halqa diagramma',
    radar: 'Radar diagramma',
    donutShort: 'Halqa',
    radarShort: 'Radar',
    noData: 'Ma’lumot topilmadi',
  },
  home: {
    title: 'Asosiy',
    myIndex: 'Ma’naviy indeksim',
    eyebrow: 'Şaxsiy körsatkiç',
    indexOf100: '100 ballik indeks',
    recommended: 'Tavsiya etiladi',
    recommendedFor: '«{axis}» yönalişi böyiça tanlandi.',
    recommendedWeakest: 'Eng past yönaliş böyiça tanlandi.',
    recommendedNote: 'Indikatorni bosib boşqa yönalişdan kitob tanlang.',
    noRecommendation: 'Hamma yönaliş böyiça kitob topşirilgan.',
    nextExam: 'Eng yaqin imtihon',
    openBook: 'Kitobni oçiş',
    greeting: 'Xuş kelibsiz',
    greetingName: 'Xuş kelibsiz, {name}',
    lead: 'Kitob tanlang, öqing va imtihon topşiring — körsatkiçingiz şu yerda ösadi.',
  },
  myStats: {
    title: 'Körsatkiçlarim',
    sub: 'Öqiş va imtihon natijalaringiz',
    index: 'Ma’naviy indeksim',
    indexSub: 'Beşta yönaliş, har biri 100 ballik şkalada',
    passedBooks: 'Topşirilgan kitoblar',
    scheduled: 'Rejalaştirilgan',
    favorites: 'Sevimlilar',
    averageScore: 'Örtaça natija',
    totalScore: 'Jami ball',
    examCount: 'Imtihonlar',
    activity: 'Oylik faollik',
    activitySub: 'Oyiga neçta imtihon topşirilgan',
    spheres: 'Yönalişlar kesimida',
    spheresSub: 'Topşirilgan kitoblar soni',
    inProgress: 'Davom etayotganlar',
    inProgressSub: 'Rejalaştirilgan va qayta topşiriladigan kitoblar',
    noExams: 'Hali imtihon topşirmagansiz',
    noExamsText: 'Kutubxonadan kitob tanlang va imtihonni rejalaştiring.',
  },
  statistics: {
    title: 'Statistika',
    sub: 'Taşkilot böyiça umumiy körsatkiçlar',
    employees: 'Jami xodimlar soni',
    employeesSource: {
      manual: 'Qölda kiritilgan',
      hr: 'HR tizimidan',
      none: 'Ma’lumot yöq',
    },
    employeesEdit: 'Xodimlar sonini tahrirlaş',
    employeesHint:
      'Qölda kiritilgan son HR tizimidagidan ustun turadi va ma’naviy indeksni hisoblaşda işlatiladi. Uni öçirsangiz, son yana HR tizimidan olinadi.',
    employeesHr: 'HR tizimida',
    employeesHrUnavailable: 'olib bölmadi',
    employeesManual: 'Qölda kiritilgan',
    employeesManualBy: '{name}, {date}',
    employeesInput: 'Xodimlar soni',
    employeesReset: 'HR’dagi songa qaytiş',
    employeesSaved: 'Xodimlar soni saqlandi',
    employeesResetDone: 'Endi son HR tizimidan olinadi',
    books: 'Jami kitoblar soni',
    scheduled: 'Test topşirişga röyxatdan ötganlar',
    index: 'Xodimlarning ma’naviy indeksi',
    indexSub: 'Soha kesimida, tanlangan davr böyiça',
    readStats: 'Eng köp öqilgan yönaliş',
    readStatsSub: 'Umumiy: {total} ta öqilgan kitob',
    sphereIndex: 'Sohaviy kitoblar indeksi',
    leaderboard: 'Reyting ballari',
    leaderboardSub: 'Davr böyiça eng köp ball yiğganlar',
    age: 'Xodimlar yoşi',
    ageSub: 'Yoş guruhlari böyiça taqsimot',
    gender: 'Xodimlar jinsi',
    genderSub: 'Umumiy: {total} ta',
    education: 'Xodimlar ma’lumoti',
    educationSub: 'Ta’lim darajasi böyiça taqsimot',
    staffUnavailable: 'Kadrlar kesimi hozirça mavjud emas (HR state servisi)',
  },
  age: {
    upTo30: '30 yoşgaça',
    from30To40: '30 dan 40 yoşgaça',
    over40: '40 yoşdan katta',
    retired: 'Nafaqadagilar',
  },
  gender: {
    male: 'Erkaklar',
    female: 'Ayollar',
  },
  education: {
    high: 'Oliy',
    mediumSpecial: 'Örta maxsus',
    medium: 'Örta',
    none: 'Körsatilmagan',
  },
  sphere: {
    ethical: 'Axloqiy',
    professional: 'Kasbiy',
    'legal-disciplinary': 'Huquqiy-intizomiy',
    'spiritual-educational': 'Ma’naviy-ma’rifiy',
    physical: 'Jismoniy',
  },
  employeeBookStatus: {
    exam_scheduled: 'Imtihon rejalaştirilgan',
    exam_in_process: 'Imtihon jarayonda',
    exam_retake: 'Qayta topşiriş',
    exam_passed: 'Topşirilgan',
    exam_failed: 'Topşirilmagan',
  },
  examStatus: {
    in_process: 'Jarayonda',
    passed: 'Ötdi',
    failed: 'Ötmadi',
    overdue: 'Muddati ötgan',
  },
  library: {
    title: 'Kutubxona',
    sub: 'Kitob tanlang, öqing va imtihon topşiring',
    favorites: 'Sevimlilar',
    enrolled: 'Rejalaştirilgan',
    catalog: 'Katalog',
    scheduleExam: 'Imtihonni rejalaştiriş',
    startExam: 'Imtihonni boşlaş',
    retakeExam: 'Qayta topşiriş',
    rate: 'Baholaş',
    ebook: 'Elektron kitob',
    read: 'Öqiş',
    audiobook: 'Audiokitob',
    downloads: 'yuklab olingan',
    passedCount: 'marta topşirilgan',
    questionsNotEnough: 'Savollar hali tayyor emas',
    bonus: 'bonus',
    noCover: 'Muqova yöq',
    searchPlaceholder: 'Kitob nomi yoki muallif (kamida 4 belgi)',
    myIndex: 'Ma’naviy indeksim',
    results: 'Natijalar',
    searchShort: 'Kitob, muallif…',
    passed: 'Topşirilgan',
    retake: 'Qayta topşiriş',
    shelf: 'Javon',
    shelfSub: 'Holat böyiça tanlang — röyxat şu zahoti yangilanadi',
    statusFilter: 'Holat',
    resultsFor: '«{q}» böyiça',
    foundCount: '{n} ta kitob topildi',
    searchOther: 'Boşqa söz bilan qidirib köring yoki holatni özgartiring.',
    empty: 'Kutubxona böş',
    emptyText: 'Taşkilotingizga hali kitob qöşilmagan.',
    wholeCatalog: 'Butun katalog',
    bookCount: '{n} ta kitob',
    inFavorites: 'Sevimlilarda',
    toFavorites: 'Sevimlilarga',
    favoriteAdded: 'Sevimlilarga qöşildi',
    favoriteRemoved: 'Sevimlilardan olib taşlandi',
    notFound: 'Kitob topilmadi',
    bookInfo: 'Kitob ma’lumotlari',
    size: 'Hajmi',
    readersRating: 'Kitobxonlar bahosi',
    passedTimes: '{n} marta topşirilgan',
    downloaded: 'Yuklab olingan',
    youPassed: 'Siz topşirgansiz',
    continueExam: 'Imtihonni davom ettiriş',
    viewResult: 'Natijani köriş',
    attemptsOver: 'Urinişlar tugagan — kitob yopilgan',
    editEvent: 'Tadbirni tahrirlaş',
    rails: {
      enrolledSub: 'Imtihon rejalaştirilgan kitoblaringiz',
      retakeSub: 'Qayta topşiriş kerak bölgan kitoblar',
      new: 'Yangi qöşilganlar',
      newSub: 'Kutubxonaga sönggi qöşilgan kitoblar',
      top: 'Kitobxonlar bahosi',
      topSub: 'Eng yuqori baho olgan kitoblar',
      popular: 'Köp topşirilgan',
      popularSub: 'Hamkasblar eng köp imtihon topşirgan kitoblar',
      favoritesSub: 'Belgilab qöygan kitoblaringiz',
      bonus: 'Bonusli kitoblar',
      bonusSub: 'Topşirsangiz qöşimça foiz beradi',
      sameAuthor: 'Şu muallifdan',
      sameAuthorSub: '{author} qalamiga mansub boşqa kitoblar',
      similar: 'Öxşaş kitoblar',
      similarSub: 'Şu janrdagi tanlov',
      others: 'Boşqa kitoblar',
      othersSub: 'Kutubxonadan',
    },
  },
  /** O'qish oynasi (prototip reader.html) */
  reader: {
    back: 'Kitob sahifasiga qaytiş',
    opening: 'Kitob oçilmoqda…',
    toolbar: 'Öqiş asboblari',
    pageInput: 'Sahifa raqami',
    pageOf: '/ {n}',
    read: '{n}% öqildi',
    prevPage: 'Oldingi sahifa',
    nextPage: 'Keyingi sahifa',
    outline: 'Mundarija',
    noOutline: 'Bu kitobda mundarija yöq. Sahifaga ötiş uçun yuqoridagi raqamni özgartiring.',
    search: 'Kitobdan qidiriş',
    searchPlaceholder: 'Söz yoki ibora…',
    searchPrev: 'Oldingi topilma',
    searchNext: 'Keyingi topilma',
    searching: 'Qidirilmoqda…',
    notFound: 'Topilmadi',
    matches: '{current} / {total} ta topilma',
    wrapped: 'Kitob oxiriga yetildi — boşidan davom etdi',
    bookmarks: 'Belgilangan sahifalar',
    addBookmark: 'Şu sahifani belgilaş',
    removeBookmark: 'Belgini olib taşlaş',
    noBookmarks:
      'Hali belgi yöq. Muhim sahifani belgilab qöying — keyin şu yerdan bir bosişda qaytasiz.',
    pageN: '{n}-sahifa',
    settings: 'Öqiş sozlamalari',
    zoom: 'Masştab',
    zoomIn: 'Kattalaştiriş',
    zoomOut: 'Kiçraytiriş',
    fitTo: 'Moslaş',
    fit: {
      auto: 'Avto',
      'page-width': 'Kenglik',
      'page-fit': 'Sahifa',
    },
    paper: 'Fon',
    papers: {
      light: 'Oq',
      sepia: 'Sepiya',
      dark: 'Tun',
    },
    fullscreen: 'Töliq ekran',
    exitFullscreen: 'Töliq ekrandan çiqiş',
    download: 'Yuklab oliş',
    noEbook: 'Bu kitobning elektron nusxasi yöq',
    noEbookText: 'Kitob sahifasida boşqa ma’lumotlarni körişingiz mumkin.',
    toBook: 'Kitob sahifasi',
    cantOpen: 'Kitobni oçib bölmadi',
    errors: {
      invalid: 'Fayl PDF emas yoki şikastlangan. Kitobni yuklab olib öqing.',
      password: 'Bu PDF parol bilan himoyalangan. Kitobni yuklab olib öqing.',
      missing: 'Kitob fayli serverda topilmadi. Administratorga murojaat qiling.',
      network: '{message}. Internet aloqasini tekşirib, qayta urinib köring.',
    },
  },
  hero: {
    todayExam: 'Bugungi imtihon',
    todayShelf: 'Bugungi javon',
    examTime: 'Imtihon vaqti',
    today: 'bugun',
    dailyChapter: 'har kuni bir bob.',
    toExam: 'Kitobdan imtihongaça.',
    lead: 'Taşkilot kutubxonasidan kitob tanlang, öqing va imtihon topşiring. Har topşirilgan kitob körsatkiçingizni oşiradi.',
    goToExam: 'Imtihonga ötiş',
    openBook: 'Kitobni oçiş',
    pickForMe: 'Menga kitob tanlab ber',
    books: 'Kitoblar',
    passed: 'Topşirilgan',
    index: 'Körsatkiç',
    scheduledExam: 'Rejalaştirilgan imtihon',
    catalogCard: 'Katalog kartoçkasi',
    event: 'Tadbir',
    booksPassed: '{passed} / {total} kitob topşirilgan',
  },
  schedule: {
    title: 'Imtihonni rejalaştiriş',
    eventName: 'Tadbir nomi',
    time: 'Imtihon vaqti',
    description: 'Izoh',
    color: 'Rang',
    scheduled: 'Imtihon rejalaştirildi',
    updated: 'Tadbir yangilandi',
    eventNamePlaceholder: 'Masalan: Imtihon — Ötkan kunlar',
    timePlaceholder: 'Sana va vaqt',
    descriptionPlaceholder: 'Ixtiyoriy',
    rated: 'Bahoyingiz uçun rahmat',
    ratingComment: 'Fikringiz (ixtiyoriy)',
    submit: 'Rejalaştiriş',
    edit: 'Tadbirni tahrirlaş',
    delete: 'Tadbirni öçiriş',
    deleteConfirm: 'Bu tadbirni öçirasizmi? Bu kitob böyiça boşqa tadbir bölmasa, rejadan çiqadi.',
  },
  exam: {
    title: 'Imtihon',
    question: 'Savol',
    of: '/',
    next: 'Keyingi',
    prev: 'Oldingi',
    finish: 'Yakunlaş',
    finishConfirm: 'Imtihonni yakunlaysizmi? Javob berilmagan savollar notöğri hisoblanadi.',
    timeLeft: 'Qolgan vaqt',
    answered: 'Javob berildi',
    unanswered: 'Javob berilmagan',
    cameraRequired: 'Imtihon uçun kamera kerak',
    cameraHint:
      'Imtihon davomida video yozib boriladi. Kameraga ruxsat bering va yuzingiz aniq körinsin.',
    allowCamera: 'Kameraga ruxsat beriş',
    starting: 'Imtihon boşlanmoqda…',
    recording: 'Yozilmoqda',
    violations: 'Ogohlantirişlar',
    tabWarning: 'Diqqat: imtihon oynasidan çiqiş qoidabuzarlik sifatida qayd etiladi.',
    result: 'Imtihon natijasi',
    passed: 'Tabriklaymiz, imtihondan ötdingiz!',
    failed: 'Afsuski, imtihondan öta olmadingiz.',
    percent: 'Natija',
    passingScore: 'Ötiş çegarasi',
    rateBook: 'Kitobni baholang',
    yourRating: 'Sizning bahoyingiz',
    backToLibrary: 'Kutubxonaga qaytiş',
    myExams: 'Imtihonlarim',
    myExamsSub: 'Topşirgan va jarayondagi imtihonlaringiz',
    adminSub: 'Xodimlar topşirgan va jarayondagi imtihonlar',
    none: 'Imtihonlar yöq',
    noneText: 'Kutubxonadan kitob tanlab imtihonni rejalaştiring.',
    correctAnswers: 'Töğri javoblar',
    correctAnswer: 'Töğri javob',
    continue: 'Davom etiş',
    resultShort: 'Natija',
    byQuestion: 'Savollar böyiça',
    legend: 'Yaşil — töğri, qizil — notöğri, kulrang — javob berilmagan.',
    noBreakdown: 'Bu imtihon uçun savollar kesimi saqlanmagan — faqat umumiy natija mavjud.',
    reviewTitle: 'Kitobni qayta öqib çiqişni tavsiya qilamiz',
    reviewText:
      'Töğri javob berilmagan savollar kitobning quyidagi sahifalariga asoslangan. Mavzuni mustahkamlaş uçun ularni diqqat bilan qayta öqib çiqing.',
    reviewTextRetake:
      'Töğri javob berilmagan savollar kitobning quyidagi sahifalariga asoslangan. Imtihonni qayta topşirişdan oldin ularni diqqat bilan öqib çiqing.',
    reviewHint: 'Sahifani bosing — kitob yangi oynada öşa joydan oçiladi.',
    reviewPage: '{n}-sahifa',
    reviewPages: '{from}–{to}-sahifalar',
    leaveConfirm:
      'Çiqsangiz imtihon jarayonda qoladi va muddati tugagaç «muddati ötgan» deb belgilanadi. Çiqasizmi?',
    leave: 'Çiqiş',
    recordingNote: 'Yozuv imtihon tugagunça davom etadi',
    questionsNote: '{title} — {n} ta savol, vaqt çeklangan',
    cardLabel: '{title}, muallif {author}',
    notFound: 'Imtihon topilmadi',
    inProcessNote: '— imtihon hali jarayonda',
    reopened:
      'Bu kitob böyiça avval boşlangan imtihon oçiq qolgan — öşa davom ettirildi. Vaqt u boşlangan paytdan hisoblanadi.',
    logsSub: 'Imtihon davomida frontend yuborgan qoidabuzarlik jurnali',
    noLogs: 'Qoidabuzarlik qayd etilmagan',
    forceFailConfirm:
      'Imtihon #{id} ({name}) holati «failed» ga ötkaziladi. Bu amalni qaytarib bölmaydi.',
    statusChanged: 'Holat özgartirildi',
    pinflSearch: 'Xodim PINFL',
    started: 'Boşlangan',
    ended: 'Yakunlangan',
    deadline: 'Muddat',
    number: 'Imtihon #{id}',
    score: 'Ball',
    scoreHint: 'Ball natijaga qarab beriladi: 40-69% — 0.1, 70-89% — 0.2, 90%+ — 0.3',
    violationCount: 'Qoidabuzarlik',
    forceFail: 'Bekor qiliş (failed)',
    video: 'Video yozuv',
    noVideo: 'Video yöq',
    summary: {
      title: 'Qoidabuzarliklar xulosasi',
      sub: 'Har bir qoida böyiça çegara va qayd etilgan soni',
      rule: 'Qoida',
      limit: 'Çegara',
      count: 'Qayd etildi',
      cause: 'Sabab',
      tabLeaves: 'Imtihon oynasidan çiqiş (jami)',
      faceEvents: 'Yuz nazorati (jami)',
      mouth: 'Gapiriş',
      more: '{n} tadan köp',
      times: '{n} marta',
      seconds: '{n} soniya uzluksiz',
      kicked: 'Imtihondan çiqarildi',
      ended: 'Yakunlaniş',
      inProcess: 'Imtihon hali davom etmoqda',
      unknown: 'Yakunlaniş sababi yozilmagan — imtihon sabab saqlaş qöşilişidan oldin yakunlangan',
      minSeconds: 'Yuz holati {n} soniyadan uzoq davom etsa qayd etiladi.',
      currentLimits: 'Bu imtihonda çegaralar saqlanmagan — joriy qiymatlar körsatilgan.',
    },
    delete: 'Imtihonni öçiriş',
    deleteTitle: 'Imtihonni öçiriş',
    deleteConfirm:
      'Imtihon #{id} ({name}) öçiriladi: savollari va javoblari, qoidabuzarlik jurnali va videosi bilan tizimda körinmay qoladi (bazada öçirilgan deb belgilanib saqlanadi). Xodimning şu kitobdagi holati qolgan imtihonlaridan qayta hisoblanadi. Ilovadan qaytarib bölmaydi.',
    deleted: 'Imtihon #{id} öçirildi',
    face: {
      rule: 'Kadrda faqat siz bölişingiz kerak: yuz 10 soniya körinmasa yoki rasm, boşqa odam aniqlansa, yuz böyiça qoidabuzarlik {faceLimit} marta qayd etilsa yoki gapiriş 10 martadan oşsa imtihon yakunlanadi',
      total: 'Yuz nazorati',
      modelsLoading: 'Yuz nazorati modullari yuklanmoqda…',
      initializing: 'Biometrik aniqlaşga tayyorlanmoqda…',
      unavailable: 'Yuz nazorati işlamayapti',
      noFace: 'Yuz aniqlanmadi',
      photo: 'Rasm aniqlandi — jonli yuz körsating',
      multiple: 'Bir neçta odam aniqlandi',
      different: 'Boşqa odam aniqlandi',
      mouth: 'Gapiriş darajasi me’yordan oşmoqda',
      mouthCount: 'Gapiriş',
    },
    /** Savollar himoyasi (`useScreenShield`): brauzer paneli ochiq / oyna faol emas */
    shield: {
      rule: 'Brauzer yon paneli (AI yordamçi va h.k.) yoki dasturçi vositalari oçilsa savollar yaşiriladi: panel {seconds} soniyada yopilmasa yoki ikkinçi marta oçilsa imtihon yakunlanadi',
      panelTitle: 'Brauzer paneli oçiq',
      panelText:
        'Imtihon davomida brauzerning yon paneli (AI yordamçi, xatçöplar va h.k.) va dasturçi vositalari yopiq bölişi kerak. Panelni yoping — savollar yana körinadi. Ikkinçi marta oçilsa imtihon yakunlanadi.',
      countdown: 'Yopilmasa imtihon yakunlanadi:',
      focusTitle: 'Savollar yaşirildi',
      focusText: 'Imtihon oynasi faol emas. Savollarni köriş uçun şu oynani bosing.',
      keysTitle: 'Savollar yaşirildi',
      keysText: 'Cmd / Win tugmasi bosib turilibdi — uni qöyib yuboring, savollar qaytadi.',
    },
    screenshot: {
      rule: 'Skrinşot oliş taqiqlanadi: birinçisida ogohlantiriş beriladi, ikkinçisida imtihon yakunlanadi',
      warning: 'Skrinşot aniqlandi! Yana bir marta takrorlansa imtihon yakunlanadi.',
    },
  },
  /** Qoidabuzarlik jurnali turlari (eski HR UI `CheatLogType`) */
  /** Imtihon nega yakunlangani — contracts `EXAM_FINISH_REASONS` */
  finishReason: {
    manual: 'Xodim imtihonni özi yakunladi',
    time: 'Vaqt tugadi',
    reload: 'Sahifa imtihon paytida yangilandi',
    tab_leaves: 'Imtihon oynasidan çiqiş {tab} tadan oşdi',
    face_events: 'Yuz nazorati qoidabuzarliklari {face} marta qayd etildi',
    mouth: 'Gapiriş {mouth} marta qayd etildi',
    no_face: 'Yuz {seconds} soniya davomida aniqlanmadi',
    photo: 'Jonli yuz örniga rasm {seconds} soniya davomida aniqlandi',
    multiple_faces: 'Bir neçta odam {seconds} soniya davomida aniqlandi',
    different_person: 'Boşqa odam {seconds} soniya davomida aniqlandi',
    side_panel: 'Brauzer paneli {panel} marta oçildi',
    side_panel_open: 'Brauzer paneli {panelSeconds} soniya içida yopilmadi',
    screenshot: 'Skrinşot {shots} marta qayd etildi',
    late: 'Javoblar muddat tugagandan keyin yuborildi',
    violations: 'Qoidabuzarliklar soni server çegarasidan oşdi',
    overdue: 'Imtihon yakunlanmay qoldi — muddati ötdi',
    admin: 'Administrator imtihonni bekor qildi',
  },
  logType: {
    TAB_BLUR: 'Platformadan çiqiş',
    SWITCH_ROUTE: 'Boşqa sahifaga ötiş',
    PAGE_RELOAD: 'Sahifa yangilanişi',
    FACE_NOT_DETECTED: 'Yuz aniqlanmadi',
    PHOTO_DETECTED: 'Rasm aniqlandi',
    MULTIPLE_FACES: 'Bir neçta odam',
    DIFFERENT_PERSON: 'Boşqa odam',
    MOUTH_OPENING_DETECTED: 'Gapiriş me’yordan oşdi',
    SIDE_PANEL_OPENED: 'Brauzer paneli oçildi',
    SCREENSHOT_DETECTED: 'Skrinşot',
  },
  calendar: {
    title: 'Kalendar',
    sub: 'Rejalaştirilgan imtihonlar',
    today: 'Bugun',
    prevMonth: 'Oldingi oy',
    nextMonth: 'Keyingi oy',
    weekdays: ['Du', 'Se', 'Ço', 'Pa', 'Ju', 'Şa', 'Ya'],
    months: [
      'Yanvar',
      'Fevral',
      'Mart',
      'Aprel',
      'May',
      'Iyun',
      'Iyul',
      'Avgust',
      'Sentabr',
      'Oktabr',
      'Noyabr',
      'Dekabr',
    ],
    noEvents: 'Bu kunda tadbir yöq',
    adminSub: 'Taşkilot xodimlarining rejalaştirilgan imtihonlari',
    eventDeleted: 'Tadbir öçirildi',
    dayFormat: 'DD MMMM, dddd',
  },
  difficulty: {
    easy: 'Oson',
    medium: 'Örta',
    hard: 'Qiyin',
    none: 'Belgilanmagan',
    label: 'Qiyinlik',
    title: 'Qiyinlik uluşi',
    sub: 'Imtihonda har darajadan şunça savol tasodifiy olinadi',
    sourceBook: 'Şu kitob uçun alohida',
    sourceGlobal: 'Umumiy sozlama',
    sourceDefault: 'Umumiy sozlama (standart)',
    row: 'imtihonda {plan} ta · bazada {available} ta',
    unset: 'Qiyinligi belgilanmagan: {n} ta',
    shortage: 'Savol yetmaydi: {levels} — imtihonda örni boşqa savollardan tasodifiy töldiriladi.',
    noLevels: 'Savollarda qiyinlik belgilanmagan — imtihonda uluşsiz, eskisidek tasodifiy olinadi.',
    examCount: 'Bitta imtihonda {n} ta savol',
    editBook: 'Kitob uçun özgartiriş',
    resetBook: 'Umumiyga qaytariş',
    editGlobal: 'Umumiy uluş',
    modalBook: 'Kitob uçun qiyinlik uluşi',
    modalGlobal: 'Umumiy qiyinlik uluşi',
    modalGlobalHint:
      'Bitta imtihondagi {n} ta savol darajalarga bölinadi. Alohida son berilmagan barça kitoblarga qöllanadi; kitobda biror darajada savol yetmasa, örni boşqa savollardan töldiriladi.',
    modalBookHint:
      'Bitta imtihondagi {n} ta savol darajalarga bölinadi. Har darajadan kitobdagi savollardan köp tanlab bölmaydi.',
    unit: 'ta',
    availableHint: 'bazada {n} ta',
    maxHint: 'köpi bilan {n} ta',
    sum: 'Jami: {sum} / {n} ta',
    sumInvalid: 'yiğindi {n} ta bölişi kerak',
    notEnough:
      'Kitobda qiyinligi belgilangan savollar {have} ta — imtihonga {n} ta kerak. Kitobga alohida son berib bölmaydi, umumiy sozlama işlatiladi.',
    saved: 'Qiyinlik uluşi saqlandi',
    resetConfirm: 'Kitob umumiy uluşga qaytarilsinmi?',
    resetDone: 'Kitob umumiy uluşga qaytarildi',
    pages: '{from}–{to}-betlar',
    page: '{n}-bet',
    sourceText: 'Kitobdagi manba',
  },
  aiTests: {
    title: 'AI orqali test',
    sub: 'Kitob PDF’i AI’ga yuboriladi. Agar avval savol yaratilgan bölsa, yangi savollar kitobning hozirgi savollari örnini egallaydi.',
    send: 'AI’ga yuboriş',
    resend: 'AI’ga qayta yuboriş',
    sendConfirm: 'Kitob AI’ga yuborilsinmi?',
    sendHint:
      'AI kitob böyiça savollar tuzadi (bir neça daqiqa). Savollar kelganda kitobning hozirgi barça savollari almaştiriladi.',
    sent: 'Kitob AI’ga yuborildi',
    pull: 'AI’dan qayta oliş',
    pullConfirm: 'Test AI’dan qayta olinsinmi?',
    pullHint:
      'AI bazasidagi oxirgi test olinadi va kitobning hozirgi barça savollari almaştiriladi. Kitob AI’ga qayta yuborilmaydi.',
    pulled: 'AI’dan {n} ta savol olindi',
    notSent: 'Kitob hali AI’ga yuborilmagan',
    received: 'Savollar qabul qilindi: {n} ta',
    receivedToast: 'AI savollari qabul qilindi',
    /** AI jarayonidagi har qanday xato — AI'ning matni ko'rsatilmaydi */
    processError: 'Test jarayonida xatolik yuz berdi',
    sentAt: 'Yuborilgan: {date}',
    fromAi: 'AI tomonida yuklangan · {date}',
    status: {
      queued: 'Navbatda',
      processing: 'Tahlil qilinmoqda',
      completed: 'Tayyor — savollar kutilmoqda',
      received: 'Savollar qabul qilindi',
      misdelivered: 'Savollar kelmadi',
      deliveryFailed: 'Savollar yetkazilmadi',
      failed: 'Xatolik',
    },
    phase: {
      queued: 'Navbatda — böş işçi kutilmoqda',
      markdown: 'PDF matnga ögirilmoqda',
      question_generation: 'Savollar tuzilmoqda',
      saving_result: 'Natija saqlanmoqda',
      completed: 'Savollar tayyor',
      failed: 'Xatolik',
    },
  },
  /** Har sahifadagi AI jarayonlari oynasi */
  aiTray: {
    title: 'AI jarayonlari',
    running: '{n} ta jarayon',
    collapse: 'Yiğiş',
    expand: 'Oçiş',
    dismiss: 'Yopiş',
  },
  admin: {
    dashboard: 'Körsatkiçlar',
    booksTotal: 'Kitoblar',
    scheduled: 'Rejalaştirilgan imtihonlar',
    spiritualIndex: 'Ma’naviyat indeksi',
    readStats: 'Öqilgan kitoblar (soha kesimida)',
    leaderboard: 'Reyting',
    dashboardSub: 'Taşkilot böyiça öqiş va imtihon körsatkiçlari',
    readStatsSub: 'Jami {total} ta kitob · ustun: öqilgan / jami, öngda soha indeksi',
    period: 'Davr',
    booksSub: 'Taşkilot kutubxonasi: kitoblar, fayllar va savollar',
    newBook: 'Yangi kitob',
    editBook: 'Kitobni tahrirlaş',
    cover: 'Muqova',
    ebookFile: 'Elektron kitob fayli',
    audiobookFile: 'Audiokitob fayli',
    bonusPercent: 'Bonus (%)',
    questions: 'Savollar',
    importQuestions: 'Excel’dan yuklaş',
    importHint:
      'Ustunlar: Savol | A | B | C | D | Töğri javob (A–D). Kitobning eski savollari almaştiriladi.',
    skippedRows: 'Ötkazib yuborilgan qatorlar',
    organizationsSub:
      'Xodimlari tizimga kirgan taşkilotlar. Taşkilotni oçing — unga biriktirilgan kitoblar körinadi. Kitob taşkilotga kitobni tahrirlaş sahifasida biriktiriladi.',
    orgSearch: 'Taşkilot nomi yoki ID böyiça qidiriş',
    orgCount: '{n} ta taşkilot',
    orgUsers: 'Kirgan xodimlar',
    orgBooks: 'Biriktirilgan kitoblar',
    orgView: 'Köriş',
    orgDetailSub: 'ID {id} · {users} ta xodim kirgan · {books} ta kitob biriktirilgan',
    orgNoBooks: 'Bu taşkilotga kitob biriktirilmagan',
    orgNoBooksText: 'Kitobni taşkilotga kitob formasidagi «Taşkilotlar» bölimida biriktiring.',
    orgLinkedAt: 'Biriktirilgan',
    noOrganizations: 'Taşkilotlar yöq',
    noOrganizationsText: 'Xodimlar tizimga kirgaç ularning taşkilotlari şu yerda paydo böladi.',
    bookOrgs: 'Taşkilotlar',
    bookOrgsHint:
      'Tanlangan taşkilotlar xodimlari ham kitobni kutubxonada köradi. Tanlanmasa — kitob öz taşkilotingiz va a’zo taşkilotlarga körinadi.',
    bookOrgsPlaceholder: 'Taşkilotni tanlang',
    bookOrgsReadonly: 'Biriktirişni faqat super administrator özgartiradi',
    bookOrgsSaveFailed: 'Kitob saqlandi, lekin taşkilotlar saqlanmadi: {error}',
    orgOption: '{name} · {n} xodim',
    dictionariesSub: 'Kitob kartoçkasida işlatiladigan janr va mavzular',
    itemCount: '{n} ta',
    genres: 'Janrlar',
    subjects: 'Mavzular',
    name: 'Nomi',
    deleteBookConfirm: 'Kitobni öçirasizmi?',
    bookDeleted: 'Kitob öçirildi',
    bookSaved: 'Kitob saqlandi',
    bookCreated: 'Kitob qöşildi — endi savollarni kiriting',
    bookTitlePlaceholder: 'Kitob nomi',
    authorRequiredOnEdit: 'Tahrirlaşda muallif majburiy',
    ebookHint: 'Faqat PDF, {max} MB gaça — kitob tizimning özida öqiladi',
    bookInfo: 'Asosiy ma’lumotlar',
    bookFiles: 'Fayllar',
    bookPreview: 'Körinişi',
    bookPreviewSub: 'Kutubxonada kitob şunday körinadi',
    authorPlaceholder: 'Masalan: Abdulla Qodiriy',
    genrePlaceholder: 'Janrni tanlang',
    subjectPlaceholder: 'Mavzuni tanlang',
    yearPlaceholder: 'Masalan: 2024',
    pagesPlaceholder: 'Sahifalar soni',
    passedCount: 'Topşirilgan',
    bonus: 'Bonus',
    ebook: 'E-kitob',
    pdfTip: 'Elektron kitob (PDF)',
    testTip: 'Test bor: {n} ta savol',
    audio: 'Audio',
    passedBooks: 'Topşirilgan kitoblar',
    averageScore: 'Örtaça natija',
    totalScore: 'Jami ball',
    leaderboardSub: 'Yiğilgan ball böyiça (ötilmagan imtihonlar ham sanaladi)',
    questionSaved: 'Savol saqlandi',
    questionCreated: 'Savol qöşildi',
    questionDeleteConfirm: 'Savolni öçirasizmi?',
    questionDeleted: 'Savol öçirildi',
    noQuestions: 'Savollar hali yöq',
    noQuestionsText:
      'Bu kitob uçun test savollari AI orqali tayyorlanadi. Yuqoridagi «AI orqali test» bölimida kitobni AI’ga yuboring — savollar tayyor bölgaç şu yerda paydo böladi.',
    noQuestionsTextReadonly:
      'Bu kitob uçun test savollari AI orqali tayyorlanadi va tayyor bölgaç şu yerda paydo böladi.',
    newQuestion: 'Yangi savol',
    editQuestion: 'Savolni tahrirlaş',
    questionText: 'Savol matni',
    options: 'Variantlar',
    markCorrect: '— töğrisini belgilang',
    addOption: 'Variant qöşiş',
    optionPlaceholder: '{letter} varianti',
    optionCorrect: '{letter} töğri javob',
    removeOption: 'Variantni olib taşlaş',
    skippedRow: '{n}-qator:',
    importDone: 'Import bajarildi',
    importDoneSkipped: 'Import bajarildi, {n} qator ötkazib yuborildi',
    dictDeleteConfirm: '«{name}» öçirilsinmi?',
    dictDeleteHint: 'Şu qiymat biriktirilgan kitoblarda maydon böş qoladi.',
  },
} as const;
